const { Button, CircularProgress } = require("@mui/material");
const { default: useAuthDefault} = require("hooks/useAuth");

const IndieButton = ({permissionGroups, useAuthTests: useAuthProp, loading=false, ...params}) => {
    const useAuth = useAuthProp || useAuthDefault;
    const { hasPermissionGroup } = useAuth();

    if(permissionGroups && ! hasPermissionGroup(permissionGroups)) {
        return "";
    }

    return (
        <Button {...params} startIcon={loading ? <CircularProgress color="inherit" size={18} /> : params.startIcon} disabled={loading || params.disabled}></Button>
    )
}

export default IndieButton;